/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {showPopupInMenu} from '../../../common/menu/actions';
import CloseButton from '../../components/buttons/CloseButton';

class Popup extends React.Component {

    static propTypes = {
        body: React.PropTypes.object,
        showPopupInMenu: React.PropTypes.func,
        onClose: React.PropTypes.func,
        popupVisible: React.PropTypes.bool,
        hideArrows: React.PropTypes.bool,
        disabledReducer: React.PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.scrollBy = this.scrollBy.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onClose() {
        const {onClose, disabledReducer, showPopupInMenu} = this.props;
        if (typeof onClose === 'function') {
            onClose();
        }
        if (!disabledReducer) {
            showPopupInMenu(false);
        }
    }

    componentWillUnmount() {
        const {showPopupInMenu, disabledReducer} = this.props;
        if (!disabledReducer) {
            showPopupInMenu(false);
        }
    }

    scrollBy(down) {
        const div = document.getElementById("popupScroll");
        if (down) {
            div.scrollTop += 100;
        } else {
            div.scrollTop -= 100;
        }
    }

    render() {
        const {hideArrows, body, popupVisible, disabledReducer} = this.props;
        if (!disabledReducer && !popupVisible) {
            return null;
        }

        return (
            <div className="popup">
                <div className="popup-block">
                    <div className="popup-content" id="popupScroll">
                            {body}
                    </div>
                    <div className="popup-controls">

                      <div className="popup-controls-key">
                        {!hideArrows &&
                            <div className="boxBtn color-white">
                                <div className="boxBtn-inner" onClick={() => this.scrollBy(false)}>
                                    <i className="ico-up"/>
                                </div>
                            </div>
                        }
                        {!!hideArrows &&
                        <div className="boxBtn color-white">

                        </div>
                        }
                      </div>


                      <div className="popup-controls-key">
                        <div className="boxBtn color-white" onClick={this.onClose}>
                            <CloseButton/>
                        </div>
                      </div>

                      <div className="popup-controls-key">
                        {!hideArrows &&
                            <div className="boxBtn color-white">
                                <div className="boxBtn-inner" onClick={() => this.scrollBy(true)}>
                                    <i className="ico-down"/>
                                </div>
                            </div>
                        }
                      </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    popupVisible: state.menu.get('popupVisible')
}), {showPopupInMenu})(Popup);



// WEBPACK FOOTER //
// ./src/browser/menu/popup/Popup.js